import React from 'react'
import {Helmet} from "react-helmet"
import Router from '../Router'
import Content from './Content.js'

class Layout extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            Title:''
        }
    }
    componentDidMount() {

    }
    componentDidUpdate() {

    }
    componentWillUnmount() {

    }
    render() {
        const {Title} = this.state;

        return (
            <>
            <Helmet>
                <title>{Title}</title>
                <meta name="description" content={Title} />
            </Helmet>
            <React.Fragment>
                <Content>
                    <Router/>
                </Content>
            </React.Fragment>
            </>
        )
    }
}

export default Layout;
